import { MenuItem, SelectField } from "material-ui";
import React from "react";

export default function BasicSelector({ 
    value, 
    dataList = [], 
    onChange, 
    style = {}, 
    iconStyle = {}, 
    labelStyle = {},
    underlineStyle = {},
    fields = [],
    floatingLabelText = '',
    floatingLabelStyle = {},
    hintText = '',
    disabled = false,
}) {

    const renderMenuItem = (item) => {
        if (typeof item === 'object' && item !== null) {            
            const values = [];
            fields.forEach(f => values.push(item[f]));

            return (
                <MenuItem 
                    key={item._id}
                    value={item._id}
                    primaryText={values.join(" - ")}
                />
            );
        } else {
            return (
                <MenuItem 
                    key={item}
                    value={item}
                    primaryText={item}
                />
            );
        }
    }

    return (
        <SelectField
            floatingLabelText={floatingLabelText}
            hintText={hintText}
            value={value}
            onChange={onChange}
            style={{ width: '100%', ...style }}
            iconStyle={{ ...iconStyle }}
            underlineStyle={{ ...underlineStyle }}
            labelStyle={{ height: '50px', ...labelStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            autoWidth
            disabled={disabled}
        >
            {
                dataList.map((item) => renderMenuItem(item))
            }
        </SelectField>
    );
}



// WEBPACK FOOTER //
// ./app/components/TcIndex/Basic/BasicSelector.jsx